import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonIcon from "@mui/icons-material/Person";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CabinIcon from "@mui/icons-material/Cabin";
import SouthAmericaIcon from "@mui/icons-material/SouthAmerica";
import AddHomeIcon from "@mui/icons-material/AddHome";
import AttributionIcon from "@mui/icons-material/Attribution";
import calendarIm from "../../Assets/AppComponent/AttendanceImages/calendar.png";
import leaveImag from "../../Assets/AppComponent/AttendanceImages/leaveIma.png";
import permissioIma from "../../Assets/AppComponent/AttendanceImages/PermissionIm.png";
import Onduty from "../../Assets/AppComponent/AttendanceImages/OnDutyIm.png";
import Arroe from "../../Assets/AppComponent/AttendanceImages/Arrow.png";
import sitetransferimg from "../../Assets/AppComponent/AttendanceImages/siteTransfer.png";
import blockimgs from "../../Assets/AppComponent/AttendanceImages/employeeBloc.png";
import attendanceimg from "../../Assets/AppComponent/AttendanceImages/employeeList.png";



const hindiDatas = {
  LeftSide: {
    Welcome: [
      {
        id: 1,
        Heading: "Welcome....",
      },
    ],
    Content: {
      Content: [
        {
          id: 1,
          para1: "Sign in to Continue...",
        },
      ],
      ContentPassword: [
        {
          id: 1,
          para1: "Reset Your Password...",
        },
      ],
      ContentSETPassword: [
        {
          id: 1,
          para1: "Set New Password...",
        },
      ],
      VerifiContent: {
        Header: [
          {
            id: 1,
            Name: "Verification...",
          },
        ],
        Content: [
          {
            id: 1,
            OTP: "Enter OTP...",
          },
        ],
        Content2: [
          {
            id: 1,
            OTP: "OTP expires in : ...",
          },
        ],
        Content4: [
          {
            id: 1,
            OTP1: "Didn’t Receive a verification Code ?..",
          },
        ],
        Content5: [
          {
            id: 1,
            OTP2: "Resend OTP?..",
          },
        ],
      },
    },
    Content2: [
      {
        id: 1,
        para2: `Lorem Ipsum is simply dummy text of the printing and typesetting 
                industry. Lorem Ipsum has been the industry's standard dummy text ever....`,
      },
    ],
    NewPassword: {
      Header: [
        {
          id: 1,
          Header: "Reset Your Password.....",
        },
      ],
      Label1: [
        {
          id: 1,
          Label: "New Password..",
          Label2: "Confirm Password..",
        },
      ],
    },
    NewPasswordSET: {
      Header: [
        {
          id: 1,
          Header: "Set New Password...",
        },
      ],
      Label1: [
        {
          id: 1,
          Label: "Enter New Password...",
          Label2: "Confirm New Password...",
        },
      ],
    },
    Details: {
      Detail1: [
        {
          id: 1,
          Deatils: "Enter Your Details..",
        },
      ],
      Details2: [
        {
          id: 2,
          Details: "Recover Your Account...",
        },
      ],
      Details3: [
        {
          id: 1,
          Details: "Enter Your OTP..",
        },
      ],
      Details4: [
        {
          id: 1,
          Details: "Enter Your New Password....",
        },
      ],
      Details5: [
        {
          id: 1,
          Details: "Set New Password....",
        },
      ],
    },
    LoginPages: [
      {
        id: 1,
        LoginHead: "Login",
      },
    ],
    ForgotPage: [
      {
        id: 1,
        Forgot: "Forgot Password..",
      },
    ],
    InputLabel: [
      {
        id: 1,
        // labelEm: "Email or Phone Number...",
        labelEm: "Email...",

        labelPas: "Password...",
      },
    ],
    Button: {
      Button1: [
        {
          id: 1,
          ButtonName: "LOGIN...",
        },
      ],
      Button2: [
        {
          id: 1,
          ButtonNameSendOTP: "SEND OTP..",
        },
      ],
      Button3: [
        {
          id: 1,
          ButtonNameVerify: "VERIFY...",
        },
      ],
      Button4: [
        {
          id: 1,
          ButtonUpdate: "UPDATE..",
        },
      ],
    },
    ForgotPassword: [
      {
        id: 1,
        Forgot: "Forgot Password ?..",
      },
    ],
  },
  Home: {
    HomeContent: [
      {
        id: 1,
        Header: "Welcome",
      },
    ],
    ShiftDetails: [
      {
        id: 1,
        header: "TODAY SHIFT...",
      },
    ],
    LeaveApplye: [
      {
        id: 1,
        headers: "APPLY LEAVE....",
      },
    ],
    ShiftContent: {
      ShiftPart: [
        {
          id: "1",
          Head: "Shift....",
          Client: "Client...",
          Zone: "Zone...",
          Content: "Your Shift is Starting by 5 mins left.. ... ",
          Button: "CHECK IN....",
        },
      ],
    },
    ApplyLeaveCard: {
      Apply: [
        {
          id: "1",
          Header: "Available Leaves...",
          Valid: " Valid Until...",
          Button: "APPLY LEAVE...",
          Head: "ATTENDANCE...",
        },
      ],
    },

    Permissions: {
      Permission: [
        {
          id: 1,
          Header: "Available Permission ",
          valid: "Valid Until",
          Hours: "Hours Left",
        },
      ],
    },
    CardsData: {
      Data: [
        {
          id: 1,
          cardHead: "Calender",
          url: "/calender",
        },
        {
          id: 2,
          cardHead: "Leave",
          url: "/leave",
        },
        {
          id: 3,
          cardHead: "Permission",
          url: "/permission",
        },
        {
          id: 4,
          cardHead: "On Duty",
          url: "/on_duty",
        },
      ],

      BITCards: [
        {
          id: 1,
          head: "Calender...",
          image: calendarIm,
          arrow: Arroe,
        },
        {
          id: 2,
          head: "Leave...",
          image: leaveImag,
          arrow: Arroe,
        },
        // {
        //   id: 3,
        //   head: "Permission...",
        //   image: permissioIma,
        //   arrow: Arroe,
        // },
        // {
        //   id: 4,
        //   head: "On Duty...",
        //   image: Onduty,
        //   arrow: Arroe,
        // },
      ],
    },
    CardsDatateam: {
      Data: [
        {
          id: 1,
          cardHead: "Calender",
        },
        {
          id: 2,
          cardHead: "Leave",
        },
        {
          id: 3,
          cardHead: "Permission",
        },
        {
          id: 4,
          cardHead: "On Duty",
        },
      ],
    
      BITCardsTeamEmp: [
        {
          id: 1,
          head: "Employee Attendance",
          image: calendarIm,
          arrow: Arroe,
          url: "/empattendance",
        },
        {
          id: 2,
          head: "Site Transfer",
          image: sitetransferimg,
          arrow: Arroe,
          url: "/sitetransfer_emp",
        },

        {
          id: 3,
          head: "Block Employee",
          image: blockimgs,
          arrow: Arroe,
          url: "/block_emp",
        },
        {
          id: 4,
          head: "Attendance Regualrization",
          image: attendanceimg,
          arrow: Arroe,
          url: "/emp_attendance",
        },
        
      ],
    }

  },
  leave: {
    heading: "LEAVE",
    subHeading: "PENDING",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
  },
  leaveHistory: {
    heading: "LEAVE HISTORY",
    subHeading: "PENDING",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
  },
  permission: {
    heading: "PERMISSION",
    subHeading: "PERMISSION ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  onDuty: {
    heading: "ON DUTY",
    subHeading: "ON DUTY ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  Employeeattendance: {
    heading: "EMPLOYEE ATTENDANCE",
    subHeading: "EMPLOYEE ATTENDANCE ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  SiteTransferList: {
    heading: "SITE TRANSFER",
    subHeading: "SITE TRANSFER ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  BlockEmployeelan: {
    heading: "BLOCK EMPLOYEE",
    subHeading: "BLOCK EMPLOYEE ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  Attendance_regular: {
    heading: "ATTENDANCE REGULARIZATION",
    subHeading: "ATTENDANCE REGULARIZATION ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  Overtime_regular: {
    heading: "OVERTIME REGULARIZATION",
    subHeading: "OVERTIME REGULARIZATION ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },
  salary: {
    heading: "SALARY",
  },
  payslip: {
    heading: "PAYSLIP",
  },
  reimbursement: {
    heading: "REIMBURSEMENT",
  },
  HelpDeskJson: {
    heading: "HELP DESK",
    subHeading: "HELP DESK ",
    viewLeave: "VIEW LEAVE HISTORY",
    applyButton: "Apply",
    ApplyPermissionCard: {
      // id: "1",
      Header: "Available Permission hours",
      Valid: " Valid Until",
      Button: "APPLY PERMISSION",
      Head: "ATTENDANCE",
    },
  },

  DashBoard: {
    SideBarMap: {
      SideBar: [
        {
          id: 1,
          label: "Client..",
          icon: <AccountCircleIcon />,
          hrefLink: "/",
        },
        {
          id: 2,
          label: "Role...",
          icon: <PersonIcon />,
          hrefLink: "/role",
        },
        {
          id: 5,
          label: "User..",
          icon: <AttributionIcon />,
          hrefLink: "/user",
        },
      ],
      DropDown: {
        test: "test",

        Geolocation: [
          {
            id: 1,
            names: "  State..",
            Icons: <CabinIcon />,
            hrefLink: "/state",
          },
          {
            id: 2,
            names: "Region..",
            Icons: <SouthAmericaIcon />,
            hrefLink: "/region",
          },
          {
            id: 3,
            names: "Zone..",
            Icons: <AddHomeIcon />,
            hrefLink: "/zone",
          },
        ],

        Management: [
          {
            id: 1,
            names: "Employee Verification..",
            Icons: <CabinIcon />,
            hrefLink: "/employeeVerify",
          },
        ],
      },
    },
    Header: {
      Client: [
        {
          id: 1,
          Header: "Client..",
        },
      ],
      Role: [
        {
          id: 1,
          Header: "Role..",
        },
      ],
      User: [
        {
          id: 1,
          Header: "User..",
        },
      ],
    },
  },
};
export default hindiDatas;
